import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
// import { borderLeft } from '@material-ui/system';

const underlayerBackgroundColor = '#172B4D';

const useStyles = makeStyles(theme => ({
  underlayer: {
    background: underlayerBackgroundColor,
    height: '100%'
  },
  mainContainer: {
    position: 'relative',
    background: 'white',
    borderTopLeftRadius: '16px',
    borderBottomLeftRadius: '16px',
    height: '100%'
  }
}));

const MainDecorator = () => {
  const classes = useStyles();

  return (
    <div className={classes.underlayer}>
      <div className={classes.mainContainer} />
    </div>
  );
};

export default MainDecorator;
